import React from "react";
import TextInput from "../../../../common/components/shared/textInput/textInput";
import {ValidatedValue} from "../../../../helpers/validatedValue";
import Validator from "../../../../helpers/validator";
import {errorMessages} from "../../../../helpers/errorMessage";
import {routingAddresses} from "../../../../helpers/routing";
import {withRouter, RouteComponentProps} from "react-router";
import {Api} from "../../../../helpers/api";
import i18n from "../../../../i18n/i18n";
import {HttpError} from "../../../../common/components/shared/httpError/httpError";
import {AxiosResponse} from "axios";
import {HttpErrorModel} from "../../../../common/models/httpError";
import Form from "../../../../common/components/shared/form/form";
import {Utils} from "../../../../helpers/utils";
import {PackingModel} from "../../../models/packing";
import {PackingService} from "../../../services/packingService";

interface PackingFormState {
    isSubmitButtonBlocked: boolean;
    response: AxiosResponse<HttpErrorModel[] | any> | undefined;
}

interface PackingFormProps extends RouteComponentProps {
    packingData?: PackingModel | null;
    isUpdate: boolean;
}

class PackingForm extends React.Component <PackingFormProps, PackingFormState> {
    private name!: ValidatedValue<string>;

    constructor(props: any) {
        super(props);

        const packingValidators = [{
            name: "valueIsNotEmpty",
            fn: Validator.isNotEmpty,
            errorMessage: errorMessages.required
        }];

        this.name = new ValidatedValue("", packingValidators);

        this.state = {
            isSubmitButtonBlocked: false,
            response: undefined
        };
    }

    async componentDidMount() {
        this.setPackingData();
    }

    render() {
        return (
            <Form
                renderError={this.renderErrors()}
                renderContent={this.renderContent()}
                isSubmitButtonBlocked={this.state.isSubmitButtonBlocked}
                backAddress={routingAddresses.dictionaries.packing.list}
                submit={this.submit.bind(this)}
            />
        );
    }

    protected renderErrors() {
        if(!Api.isSuccess(this.state.response)) {
            return (
                <HttpError
                    response={this.state.response}
                    cause={this.getErrorMessage()}
                    translatedFields={{
                        name: i18n.t("dictionaries.packing.httpErrors.name")
                    }}
                    translatedFieldsForEmpty={{
                        name: i18n.t("dictionaries.packing.httpErrors.nameForEmpty")
                    }}
                    object={i18n.t("dictionaries.packing.httpErrors.object")}
                />
            );
        }
    }

    protected renderContent() {
        return (
            <>
                <TextInput label={i18n.t("dictionaries.packing.headers.name")} validatedValue={this.name} testId="packing-name"/>
            </>
        );
    }

    private getErrorMessage() {
        return this.props.isUpdate
            ? i18n.t("dictionaries.packing.errors.modifyErrorSuffix")
            : i18n.t("dictionaries.packing.errors.addErrorSuffix");
    }

    public get isValid() {
        this.name.validate();

        return this.name.isValid;
    }

    private setPackingData() {
        this.name.setValue(this.props.packingData?.name || "");
    }

    private async submit() {
        this.setState({response: undefined});

        if (this.isValid) {
            this.setState({isSubmitButtonBlocked: true});
            await this.addOrModifyPacking();
            this.setState({isSubmitButtonBlocked: false});

            if (Api.isSuccess(this.state.response)) {
                this.props.history.push(routingAddresses.dictionaries.packing.list);
            }
        }
        Utils.scrollToFirstErrorMessage();
    }

    private async addOrModifyPacking(){
        if (this.props.isUpdate && this.props.packingData?.id) {
            this.setState({
                response: await PackingService.modifyPacking({
                    name: this.name.value.trim()
                }, this.props.packingData?.id)
            });
        } else {
            this.setState({
                response: await PackingService.addPacking({
                    name: this.name.value.trim()
                })
            });
        }
    }
}

export default withRouter(PackingForm);
